import { render, staticRenderFns } from "./subjectImage.vue?vue&type=template&id=407245de&scoped=true&"
import script from "./subjectImage.vue?vue&type=script&lang=js&"
export * from "./subjectImage.vue?vue&type=script&lang=js&"
import style0 from "./subjectImage.vue?vue&type=style&index=0&id=407245de&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "407245de",
  null
  
)

export default component.exports